import React from 'react';

export type EvalPeriod = '10d' | '30d' | '90d' | '180d' | '365d' | 'all';

const PERIOD_OPTIONS: {value: EvalPeriod; label: string}[] = [
  {value: '10d', label: '10d'},
  {value: '30d', label: '30d'},
  {value: '90d', label: '90d'},
  {value: '180d', label: '6mo'},
  {value: '365d', label: '1yr'},
  {value: 'all', label: 'All'},
];

interface EvalPeriodSelectorProps {
  value: EvalPeriod;
  onChange: (period: EvalPeriod) => void;
}

export default function EvalPeriodSelector({value, onChange}: EvalPeriodSelectorProps) {
  return (
    <div className="flex gap-1">
      {PERIOD_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`px-3 py-1.5 text-xs font-medium border transition-colors ${
            value === opt.value
              ? 'bg-blue-600 border-blue-600 text-white'
              : 'bg-white border-gray-200 text-gray-500 hover:border-gray-400 hover:text-gray-700'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

interface CustomDateRangeProps {
  startDate: string;
  endDate: string;
  onStartChange: (date: string) => void;
  onEndChange: (date: string) => void;
  onApply: () => void;
}

export function CustomDateRange({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  onApply,
}: CustomDateRangeProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <label className="flex items-center gap-1.5 text-xs text-gray-500">
        <span>From:</span>
        <input
          type="date"
          value={startDate}
          onChange={(e) => onStartChange(e.target.value)}
          className="px-2 py-1 text-xs border border-gray-200 bg-white text-gray-900 focus:outline-none focus:border-blue-500"
        />
      </label>
      <label className="flex items-center gap-1.5 text-xs text-gray-500">
        <span>To:</span>
        <input
          type="date"
          value={endDate}
          onChange={(e) => onEndChange(e.target.value)}
          className="px-2 py-1 text-xs border border-gray-200 bg-white text-gray-900 focus:outline-none focus:border-blue-500"
        />
      </label>
      <button
        onClick={onApply}
        className="px-3 py-1.5 text-xs font-medium bg-white border border-gray-200 text-gray-500 hover:border-gray-400 hover:text-gray-700 transition-colors"
      >
        Apply
      </button>
    </div>
  );
}
